const DataUnpinnedItemIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={16} height={16} viewBox='0 0 16 16' fill='none'>
      <path
        d='M8 11.334V14.6673'
        stroke='#4A5565'
        strokeWidth={1.33333}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.0026 7.17398C6.00247 7.42204 5.93315 7.66514 5.80242 7.87595C5.67169 8.08677 5.48475 8.25693 5.2626 8.36732L4.07594 8.96732C3.8538 9.0777 3.66685 9.24787 3.53612 9.45868C3.4054 9.66949 3.33607 9.9126 3.33594 10.1607V10.6673C3.33594 10.8441 3.40618 11.0137 3.5312 11.1387C3.65622 11.2637 3.82579 11.334 4.0026 11.334H12.0026C12.1794 11.334 12.349 11.2637 12.474 11.1387C12.599 11.0137 12.6693 10.8441 12.6693 10.6673V10.1607C12.6691 9.9126 12.5998 9.66949 12.4691 9.45868C12.3384 9.24787 12.1514 9.0777 11.9293 8.96732L10.7426 8.36732C10.5205 8.25693 10.3335 8.08677 10.2028 7.87595C10.0721 7.66514 10.0027 7.42204 10.0026 7.17398V4.66732C10.0026 4.49051 10.0728 4.32094 10.1979 4.19591C10.3229 4.07089 10.4925 4.00065 10.6693 4.00065C11.0229 4.00065 11.362 3.86018 11.6121 3.61013C11.8621 3.36008 12.0026 3.02094 12.0026 2.66732C12.0026 2.3137 11.8621 1.97456 11.6121 1.72451C11.362 1.47446 11.0229 1.33398 10.6693 1.33398H5.33594C4.98232 1.33398 4.64318 1.47446 4.39313 1.72451C4.14308 1.97456 4.0026 2.3137 4.0026 2.66732C4.0026 3.02094 4.14308 3.36008 4.39313 3.61013C4.64318 3.86018 4.98232 4.00065 5.33594 4.00065C5.51275 4.00065 5.68232 4.07089 5.80734 4.19591C5.93237 4.32094 6.0026 4.49051 6.0026 4.66732V7.17398Z'
        stroke='#4A5565'
        strokeWidth={1.33333}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default DataUnpinnedItemIcon
